export default{
  provider : {
    "BNG-AIO": "bng",
    "BTG-AIO": "bt-gaming",
    "CLP-AIO": "clotplay",
    "CQ9-AIO": "cq9",
    "DBG-AIO": "dbg-slot",
    "EPW-AIO": "epicwin",
    "EVOBTG-AIO": "big-time-gaming",
    "EVONE-AIO": "netent",
    "EVONLC-AIO": "nlc",
    "EVOPLAY-AIO": "evoplay",
    "EVORT-AIO": "redtiger",
    "FACHAI-AIO": "fc",
    "FUNTA-AIO": "funta-gaming",
    "GPD-AIO": "gaming-panda",
    "HSW-AIO": "hacksaw",
    "IMG-AIO": "lion",
    "JDB-AIO": "jdb",
    "JILI-AIO": "jili",
    "L22-AIO": "live22",
    "MGH5-AIO": "mega888",
    "NSP-AIO": "nextspin",
    "PGSOFT-AIO": "pgsoft",
    "PNG-AIO": "playngo",
    "PPLAY-AIO": "pragmatic",
    "R88-AIO": "rich88",
    "RSG-AIO": "royal-slot",
    "SPP-AIO": "simpleplay",
    "UUS-AIO": "UUslot",
    "VAG-AIO": "va-gaming",
    "WFG-AIO": "wf-gaming",
    "YBAT-AIO": "yellowbat",
    "YGR-AIO": "ygr",

    "EVOLIVE-AIO": "evo",
    "EZG-AIO": "ezugi",
    "FBL-AIO": "fb-games",
    "PPLAYLIVE-AIO": "pragmatic",
    "RGC-AIO": "g-club",
    "SAG-AIO": "sa-gaming",
    "SXB-AIO": "sexy-baccarat",

    
    
    
  },

}